import classNames from 'classnames';
import Background from './Background';
import { Container } from 'react-bootstrap';
import type { HTMLAttributes, ReactNode } from 'react';

interface SectionProps extends HTMLAttributes<HTMLElement> {
  fluid?: boolean;
  bg?: string;
  image?: string;
  overlay?: boolean | string;
  position?: string | { x?: string; y?: string };
  video?: string[];
  bgClassName?: string;
  className?: string;
  children?: ReactNode;
}

const Section = ({
  fluid = false,
  bg,
  image,
  overlay,
  position,
  video,
  bgClassName,
  className,
  children,
  ...rest
}: SectionProps) => {
  const bgProps = { image, overlay, position, video, className: bgClassName };

  return (
    <section className={classNames({ [`bg-${bg}`]: bg }, className)} {...rest}>
      {image && <Background {...bgProps} />}
      <Container fluid={fluid}>{children}</Container>
    </section>
  );
};

export default Section;
